import { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth, formatError } from "@/lib/auth";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname || "/admin", { replace: true });
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-5 pt-[120px] pb-16" data-testid="admin-login-page">
      <div className="w-full max-w-[420px]">
        <div className="flex justify-center mb-8"><Logo light size="lg" /></div>
        <div className="bg-[#f2f0ea] p-8 sm:p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={18} className="text-gold" />
            <h1 className="font-display text-2xl tracking-[0.06em] text-ink">SHOP DASHBOARD</h1>
          </div>
          <p className="text-navy/60 text-sm mb-7">Sign in to manage quotes and your gallery.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-xs tracking-[0.14em] text-navy/60 font-semibold mb-1.5">EMAIL</label>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full border border-line bg-white px-4 py-3 text-sm outline-none focus:border-navy transition-colors"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="block text-xs tracking-[0.14em] text-navy/60 font-semibold mb-1.5">PASSWORD</label>
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full border border-line bg-white px-4 py-3 text-sm outline-none focus:border-navy transition-colors"
                placeholder="••••••••"
              />
            </div>
            {error && <p className="text-red-600 text-sm" data-testid="login-error">{error}</p>}
            <button
              type="submit" disabled={loading} data-testid="login-submit-button"
              className="w-full bg-ink text-[#f2f0ea] py-3.5 text-[13px] font-bold tracking-[0.18em] hover:bg-navy transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : null}
              {loading ? "SIGNING IN…" : "SIGN IN"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
